export const routePaths = {
  AUTH: {
    ROOT: '', // '/auth',
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
    EMAIL: {
      ROOT: 'email',
      VERIFY: 'verify',
    },
    VERIFY_OTP: 'verify-otp',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD: 'reset-password',
    SIGN_OUT: 'sign-out',
    OAUTH_CALLBACK: 'callback/:provider',
  },

  PUBLIC: {
    ROOT: '',
    HELP: 'help',
    TERMS: 'terms',
    PRIVACY: 'privacy',
    PRICING: 'pricing',
    SUPPORT: 'support',
    CONTACT: 'contact',
    FAQ: 'faq',
    ABOUT_US: 'about-us',
    BLOG: 'blog',
    EXTENSION: 'extension',
    FEATURES: {
      ROOT: 'features',
      CROSS_PLATFORM: 'cross-platform',
      AI_ASSISTANT: 'ai-assistant',
      CRISIS_DETECTOR: 'crisis-detection',
      REPORTING: 'reporting',
      DASHBOARD: 'dashboard',
    },
  },

  APP: {
    ROOT: '',
    DASHBOARD: 'dash',
    ONBOARDING: 'onboarding',

    ACCOUNT: {
      ROOT: 'account',
      SETTINGS: 'settings',
      BILLINGS: 'billings',
    },

    TEAM: {
      ROOT: 'team',
      SETTINGS: 'settings',
      MEMBERS: 'members',
      BILLING: 'billing',
    },

    YOUTUBE: {
      ROOT: 'youtube',
      ANALYTICS: 'analytics',
      COMMENTS: 'comments',
      LIVECHAT: 'live-chat',
    },

    TIKTOK: {
      ROOT: 'tiktok',
      ANALYTICS: 'analytics',
      COMMENTS: 'comments',
    },
  },
};